module.exports = [{"type":"title","text":"2024-01-23"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual contract new: Query marked price K-line data"},{"type":"html","text":"Perpetual contract: New WS DataType - 24-hour price change push"},{"type":"html","text":"Perpetual contract: New WS DataType - Latest transaction price push"},{"type":"html","text":"Perpetual contract: New WS DataType - Latest marked price push"},{"type":"html","text":"New: User queries recharge records in risk control interface."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-01-23.json
// module id = FtO6
// module chunks = 3